var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.00195312,
    width: 72,
    height: 72,
    rx: 13.0909,
    fill: "#D0F4D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5583 47.2469L20 35.6888L22.0515 33.6373L31.5583 43.1439L49.9486 24.7539L52 26.8055L31.5583 47.2469Z",
    fill: "#14D527"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.ef53fb6127bdcf741bd345fc3561e24e.svg";
export { ForwardRef as ReactComponent };